export function loadUpgradeBannerList() {
  return {
    type: 'LOAD_UPGRADE_BANNER_LIST',
  };
}

export function loadUpgradeBannerListCompletion(error, list) {
  return {
    type: 'LOAD_UPGRADE_BANNER_LIST_COMPLETION',
    error,
    list,
  };
}
